module.exports = __webpack_public_path__ + "ffdc0e37695254ba5fb9e6819470538f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/collaboration-icon.png
// module id = 510
// module chunks = 0